export const setDocumentsList = (state, reqResponse) => {
    state.documentList = reqResponse.data;
    state.loadingDocuments = false;
};

export const deleteDocument = (state, document) => {
    state.documentList.splice(state.documentList.indexOf(document), 1);
};
